import { injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import { ChecklistTemplateFilterState } from "Store/ChecklistTemplates/ChecklistTemplateFilterState";
import { IChecklistTemplateFilterFactory } from "./IChecklistTemplateFilterFactory";

@injectable()
export class ChecklistTemplateFilterFactory implements IChecklistTemplateFilterFactory {
    public create(filterState: ChecklistTemplateFilterState): TemplateFilter {
        return {
            skip: filterState.skip,
            take: filterState.take,
            query: filterState.query,

            areaIds: this.getAreaIds(filterState.area),
            roles: filterState.roles,
            instructionsAttached: filterState.instructionsAttached,
            photoAttached: filterState.photoAttached
        };
    }

    private getAreaIds(selectedArea?: Area): number[] | undefined {
        if (selectedArea) {
            const getAreaIdsOfArea = (area: Area): number[] => {
                const arr = [area.id];

                if (area.children) {
                    return arr.concat(...area.children.map(x => getAreaIdsOfArea(x)));
                }

                return arr;
            };

            return getAreaIdsOfArea(selectedArea);
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/Factories/Checklists/ChecklistTemplateFilterFactory.ts